import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const termTutor = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    termId: z.number().hidden().describe('Foreign key to Term'),

    tutorId: z.number().presentAs('reference').describe('Foreign key to Tutor'),

    term: belongsTo('Term'),

    tutor: references('Tutor'),

    activityAssignments: hasMany('ActivityAssignment'),

    studentAssignments: hasMany('StudentAssignment'),

    notAvailables: hasMany('NotAvailable'),

    attendances: hasMany('Attendance'),
  })
  .describe('Joins a tutor to a term and owns their activity assignments.')
  .as('TermTutor');

export { termTutor as termTutorSchema };
